import { AxiosInstance } from "axios";

export default (httpClient: AxiosInstance) => ({
    Listar: async () => {
        const response = await httpClient.get(`/Atendimento/listar`);
        let erros = null;
        if (!response.data) {
            erros = {
                status: response.request.status,
                statusText: response.request.statusText
            };
        }
        return {
            data: response.data,
            erros: erros
        };
    },
    ListarPorId: async (pId: number) => {
        const response = await httpClient.get(`/Atendimento/id?id=${pId}`);

        let erros = null;
        if (!response.data) {
            erros = {
                status: response.request.status,
                statusText: response.request.statusText
            };
        }
        return {
            data: response.data,
            erros: erros
        };
    },
    Inserir: async (pObj: Record<string, unknown>) => {
        const response = await httpClient.post(`/Atendimento/inserir`, pObj);

        let erros = null;
        if (!response.data) {
            erros = {
                status: response.request.status,
                statusText: response.request.statusText
            };
        }
        return {
            data: response.data,
            erros: erros
        };
    },
    Alterar: async (pObj: Record<string, unknown>) => {
        const response = await httpClient.post(`/Atendimento/alterar`, pObj);

        let erros = null;
        if (!response.data) {
            erros = {
                status: response.request.status,
                statusText: response.request.statusText
            };
        }
        return {
            data: response.data,
            erros: erros
        };
    },
    Excluir: async (pId: number) => {
        const response = await httpClient.post(`/Atendimento/excluir?id=${pId}`);

        let erros = null;
        if (!response.data) {
            erros = {
                status: response.request.status,
                statusText: response.request.statusText
            };
        }
        return {
            data: response.data,
            erros: erros
        };
    },
    AtendimentoProcedimento: async (pId: number) => {
        const response = await httpClient.get(`/Atendimento/ProcedimentoListar?pIdAtendimento=${pId}`);

        let erros = null;
        if (!response.data) {
            erros = {
                status: response.request.status,
                statusText: response.request.statusText
            };
        }
        return {
            data: response.data,
            erros: erros
        };
    },
    AtendimentoProcedimentoInserir: async (pObj: Record<string, unknown>) => {
        const response = await httpClient.post(`/Atendimento/ProcedimentoInserir`, pObj);

        let erros = null;
        if (!response.data) {
            erros = {
                status: response.request.status,
                statusText: response.request.statusText
            };
        }
        return {
            data: response.data,
            erros: erros
        };
    },
    AtendimentoProcedimentoAlterar: async (pObj: Record<string, unknown>) => {
        const response = await httpClient.post(`/Atendimento/ProcedimentoAlterar`, pObj);

        let erros = null;
        if (!response.data) {
            erros = {
                status: response.request.status,
                statusText: response.request.statusText
            };
        }
        return {
            data: response.data,
            erros: erros
        };
    },
    AtendimentoProcedimentoExcluir: async (pIdAtendimento: number, pItem: number) => {
        const response = await httpClient.post(`/Atendimento/ProcedimentoExcluir?pIdAtendimento=${pIdAtendimento}&pItem=${pItem}`);

        let erros = null;
        if (!response.data) {
            erros = {
                status: response.request.status,
                statusText: response.request.statusText
            };
        }
        return {
            data: response.data,
            erros: erros
        };
    },
    AtendimentoValorTotal: async (pIdAtendimento: number) => {
        const response = await httpClient.get(`/Atendimento/ValorTotal?pIdAtendimento=${pIdAtendimento}`);
        let erros = null;
        if (!response.data) {
            erros = {
                status: response.request.status,
                statusText: response.request.statusText
            };
        }
        return {
            data: response.data,
            erros: erros
        };

    },
    AgendaGerarAtendimento: async (pId: number) => {
        const response = await httpClient.post(`/Agenda/gerarAtendimento?pId=${pId}`);
        let erros = null;
        if (!response.data) {
            erros = {
                status: response.request.status,
                statusText: response.request.statusText
            };
        }
        return {
            data: response.data,
            erros: erros
        };

    },
    AgendaVerAtendimento: async (pId: number) => {
        const response = await httpClient.post(`/Agenda/verAtendimento?pId=${pId}`);
        let erros = null;
        if (!response.data) {
            erros = {
                status: response.request.status,
                statusText: response.request.statusText
            };
        }
        return {
            data: response.data,
            erros: erros
        };

    },
    SeqGenerator: async () => {
        const response = await httpClient.get(`/Relatorio/generator?sequence=SEQ_ATENDIMENTO_ID`);
        let erros = null;
        if (!response.data) {
            erros = {
                status: response.request.status,
                statusText: response.request.statusText
            };
        }
        return {
            data: response.data,
            erros: erros
        };

    },
});